// derivato dal flusso:
// http://github.com/hotwired/turbo/blob/82791193f95fd949592af10a0df919e72689065c/src/http/fetch_request.js#L165
// https://github.com/hotwired/turbo/blob/82791193f95fd949592af10a0df919e72689065c/src/core/drive/preloader.js#L49
// https://github.com/hotwired/turbo/blob/82791193f95fd949592af10a0df919e72689065c/src/core/drive/page_renderer.js#L38
// https://github.com/hotwired/turbo/blob/82791193f95fd949592af10a0df919e72689065c/src/core/drive/page_renderer.js#L5

import { PageRenderer, PageSnapshot } from "@hotwired/turbo"

export async function fetchAndRender(url, options, config={}){
  const { target = 'document' } = config
  const targetEl = target == 'document' ? document.documentElement : document.querySelector(target)
  const currentSnapshot = PageSnapshot.fromElement(targetEl)

  const response = await fetch(url, options)
  if(!response.ok) throw response

  const html = await response.text()

  if(target == 'document'){
    const newSnapshot = PageSnapshot.fromHTMLString(html)
    const renderer = new PageRenderer(currentSnapshot, newSnapshot)
    return await renderer.render() // calls PageRenderer.renderElement and executes turbo events (morph)
  }else{
    return window.Alpine.morph(targetEl, html)
  }
}